'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _layout = require('../layout');

exports["default"] = _layout.Row;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/antd/lib/row/index.js
 ** module id = 1079
 ** module chunks = 0
 **/